import { isAllowedTrigger } from './OdigeoInteractions';

export const LocalStorageUtils = {
    getJSON(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowedTrigger('localStorage', key) ? JSON.parse(localStorage.getItem(key)) : null;
        } catch (err) {
            return null;
        }
    },
    setJSON(key, value) {
        try {
            if (isAllowedTrigger('localStorage', key)) {
                localStorage.setItem(key, JSON.stringify(value)); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            // Ignore
        }
    },
    getValue(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowedTrigger('localStorage', key) ? localStorage.getItem(key) : null;
        } catch (err) {
            console.error(err);
            return null;
        }
    },
    setValue(key, value) {
        try {
            if (isAllowedTrigger('localStorage', key)) {
                localStorage.setItem(key, value); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            console.error(err);
        }
    }
};
